'use client';

import Link from 'next/link';
import { CalendarDays, Pencil } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

type Props = {
  clubId: string;
  /** この部活の部長全員。部長は全員対等なので、含まれていれば操作できる */
  leaderIds: string[];
};

export default function ClubLeaderActions({ clubId, leaderIds }: Props) {
  const { user, loading } = useAuth();

  if (loading || !user?.memberId || !leaderIds.includes(user.memberId)) {
    return null;
  }

  const linkClass =
    'inline-flex items-center gap-2 border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors';

  return (
    <div className='flex flex-col items-start gap-3'>
      <Link href={`/clubs/${clubId}/edit`} className={linkClass}>
        <Pencil size={14} />
        部活情報を編集
      </Link>
      <Link href={`/clubs/${clubId}/events`} className={linkClass}>
        <CalendarDays size={14} />
        イベントを管理
      </Link>
    </div>
  );
}
